import React from 'react';
import { CircularProgress } from '@mui/material'

function Progress() {

  return (
    <div className="" style={{'margintop' : '30' }}>
    {
      <CircularProgress />
    }
    </div>
  );
}

export default Progress;
